import React from 'react'
import copyWright from '../util/copyright'

const contactDetails = [
    {
        name: "Email",
        link: "mailto:info@groundcrew.com.au"
    },
    {
        name: "Instagram",
        link: "https://instagram.com/groundcrew.com.au"
    },
    {
        //TODO add correct link
        name: "LinkedIn",
        link: "https://instagram.com/groundcrew.com.au"
    }
]

const adress = [
    '22 Ross Street',
    'Newstead, qld 4006',
    'Australia'
]




export default function Contact({ className }) {
    return (
        <div className='grid grid-2 gap-0 text-white uppercase p10 align-bottom  border-box'>
            <div>
                {contactDetails.map((contact, index) => {
                    return <a key={index} className={'block lh-08 link op-link  ' + className} href={contact.link}>{contact.name}</a>
                })}
            </div>
            <div className='flex justify-sb'>
                <div className=''>
                    {adress.map((line, index) => {
                        return <span key={index} className={'block lh-08 ' + className}>{line}</span>
                    })}
                </div>
                <div className={'flex flex-col justify-end lh-08 ' + className}>
                    {copyWright(new Date().getFullYear())}
                </div>
            </div>
        </div>
    )
}
